import { Link } from 'react-router-dom'
import { Card, FormControl, FormSelect, Table } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import Pagination from '../reusable/Pagination'
import fetchData from '../utils/fetchData'
import getCookie from '../utils/getCookie'
import formatDate from '../utils/formatDate'

const statusClass = {
  paid: 'status-outline-success',
  pending: 'status-outline-warning',
  failed: 'status-outline-danger',
  cancelled: 'status-outline-danger',
}

const StoreOrder = () => {
  const [storeOrders, setStoreOrders] = useState([])
  const [filter, setFilter] = useState({ search: '', paymentStatus: '' })
  const [page, setPage] = useState(1)
  const [total, setTotal] = useState(0)
  const [limit] = useState(10)

  const getStoreOrders = async () => {
    try {
      const { data } = await fetchData.get(
        `/storeOrder?page=${page}&limit=${limit}&filter=${JSON.stringify(
          filter
        )}`,
        { headers: { Authorization: `Bearer ${getCookie('eyevaryToken')}` } }
      )
      setTotal(data?.total)
      setStoreOrders(data?.storeOrders)
    } catch (error) {
      console.log({ ...error }, error)
    }
  }
  useEffect(() => {
    getStoreOrders()
  }, [page, limit, filter])
  useEffect(() => {
    setPage(1)
  }, [filter])

  return (
    <section className='content-wrapper'>
      <Card className='mb-4'>
        <Card.Body>
          <Card.Title className='mb-3'>Store Orders</Card.Title>
          <div className='filter'>
            <div>
              <FormControl
                type='text'
                placeholder='Search buyer, product, tran id'
                autoComplete='off'
                name='search'
                value={filter.search}
                onChange={({ target }) =>
                  setFilter({ ...filter, [target.name]: target.value })
                }
              />
            </div>
            <div>
              <FormSelect
                name='paymentStatus'
                value={filter.paymentStatus}
                onChange={({ target }) =>
                  setFilter({ ...filter, [target.name]: target.value })
                }>
                <option value=''>All statuses</option>
                <option value='pending'>Pending</option>
                <option value='paid'>Paid</option>
                <option value='failed'>Failed</option>
                <option value='cancelled'>Cancelled</option>
              </FormSelect>
            </div>
          </div>
          <Table className='text-nowrap' responsive>
            <thead>
              <tr>
                <th>Order</th>
                <th>Buyer</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {storeOrders?.map((item) => (
                <tr key={item?._id}>
                  <td className='align-middle'>
                    <h6 className='mb-0'>{item?.product?.title}</h6>
                    <small>{item?.tranId}</small>
                  </td>
                  <td className='align-middle'>
                    <h6 className='mb-0'>{item?.buyer?.name}</h6>
                    <small>
                      {item?.buyer?.phone} · {item?.buyer?.email}
                    </small>
                  </td>
                  <td className='align-middle'>
                    ৳{item?.payableAmount}
                    {item?.isPreOrder && (
                      <div>
                        <small>
                          Full ৳{item?.fullAmount}
                          {item?.dueAmount != null
                            ? ` · Due ৳${item.dueAmount}${
                                item.dueStatus && item.dueStatus !== 'n/a'
                                  ? ` (${item.dueStatus})`
                                  : ''
                              }`
                            : ''}
                        </small>
                      </div>
                    )}
                  </td>
                  <td className='align-middle'>
                    <span
                      className={`status ${
                        statusClass[item?.paymentStatus] || ''
                      }`}>
                      {item?.paymentStatus}
                    </span>
                  </td>
                  <td className='align-middle'>
                    {formatDate({
                      date: item?.createdAt,
                      time: true,
                      divider: ' - ',
                    })}
                  </td>
                  <td className='align-middle text-end'>
                    <Link
                      to={`/store-orders/${item?._id}`}
                      className='btn btn-outline-danger btn-sm'>
                      <i className='mdi mdi-receipt me-1'></i> Invoice
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Pagination
            page={page}
            setPage={setPage}
            total={total}
            limit={limit}
          />
        </Card.Body>
      </Card>
    </section>
  )
}

export default StoreOrder
